define(
  'favoritesLoader',[],
  () => {
    'use strict';

    const favoriteElements = document.querySelectorAll('[data-favorite-trigger]');
    const isLoggedIn = document.querySelector('[data-isloggedin="True"]');

    /**
    * @private
    * Init: update Styles
    */
    function updateStyleFavoriteAnchor() {
      const pendingItems = document.cookie.match(/pendingSaveItem=([^;]+)/);
      const cookieFavorites = pendingItems ? JSON.parse(pendingItems[1]) : [];
      const arrayFavorites = cookieFavorites.map((item) => JSON.parse(item).id);
      favoriteElements.forEach((item) => {
        const itemIndex = arrayFavorites.indexOf(item.dataset.id);
        if (itemIndex >= 0) {
          const anchorSaved = item.parentElement.querySelector('.nhs_favSaved');
          anchorSaved.style.display = 'block';

          const anchorUnSave = item.parentElement.querySelector('.nhs_favUnsave');
          anchorUnSave.style.display = 'none';
        }
      });
    }

    /**
    * @private
    * Init: Init the component
    */

    function Init() {
      require(
        ['favoritesInit'],
        (favoritesInit) => {
          favoritesInit.init();
        }
      );
      if (isLoggedIn) {
        updateStyleFavoriteAnchor();
      }
    }

    if (document.readyState === 'complete') {
      Init();
    } else {
      window.addEventListener('load', Init);
    }
  }
);

